import React from "react";

import StudentPythonIDEWrapper from "../../../components/IDEs/wrappers/student/StudentPythonIDEWrapper";
import StudentSmoothyIDEWrapper from "../../../components/IDEs/wrappers/student/StudentSmoothyIDEWrapper";
import StudentWebIDEWrapper from "../../../components/IDEs/wrappers/student/StudentWebIDEWrapper";
import { IDE_TYPE } from "../../../constants/common";
import useAuth from "../../../hooks/useAuth";

const StudentMyCodingArea = () => {
  const user = useAuth();

  if (!user || !user.IDEType) return null; // Or a fallback UI like <Loading />

  switch (user.IDEType) {
    case IDE_TYPE.SMOOTHY:
      return <StudentSmoothyIDEWrapper />;
    case IDE_TYPE.WEB:
      return <StudentWebIDEWrapper />;
    case IDE_TYPE.PYTHON:
      return <StudentPythonIDEWrapper />;
    default:
      return <div>Unsupported IDE type: {user?.IDEType}</div>;
  }
};

export default StudentMyCodingArea;
